import { TeamDataObject } from "../DataStorage/TeamDataObject";
import { LeaseHistory } from "./LeaseHistory";

export class LeasingData extends TeamDataObject {
    clientId: string;
    leaseId: string;
    leaseType: string;
    leaseUntil: Date;
    notes?: string;
    leaseHistory: LeaseHistory[] = [];

    constructor(clientId: string, leaseId: string, leaseType: string, leaseUntil: Date) {
        super();
        this.clientId = clientId;
        this.leaseId = leaseId;
        this.leaseType = leaseType;
        this.leaseUntil = leaseUntil;
    }
}
